"use client"

import { motion, useInView } from "framer-motion"
import { ReactNode, useRef } from "react"

type FadeInWhenVisibleProps = {
  children: ReactNode
  delay?: number
  duration?: number
  direction?: "up" | "down" | "left" | "right" | "none"
  amount?: number
  className?: string
}

export const FadeInWhenVisible = ({
  children,
  delay = 0,
  duration = 0.6,
  direction = "up",
  amount = 0.3,
  className = "",
}: FadeInWhenVisibleProps) => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount })

  const directionOffset = {
    up: { y: 40 },
    down: { y: -40 },
    left: { x: 40 },
    right: { x: -40 },
    none: {},
  }

  return (
    <motion.div
      ref={ref}
      initial={{
        opacity: 0,
        ...directionOffset[direction]
      }}
      animate={isInView ? {
        opacity: 1,
        x: 0,
        y: 0
      } : {
        opacity: 0,
        ...directionOffset[direction]
      }}
      transition={{
        duration,
        delay,
        ease: [0.25, 0.4, 0.25, 1] // Custom cubic-bezier for smooth animation
      }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
